(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("CustomForm", [], factory);
	else if(typeof exports === 'object')
		exports["CustomForm"] = factory();
	else
		root["CustomForm"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "CustomForm",
  props: {
    formClass: {
      type: String,
      default: function _default() {
        return "";
      }
    },
    autoFormData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    inline: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      formListData: [],
      form: {}
    };
  },

  watch: {
    form: {
      deep: true,
      handler: function handler(newVal) {
        console.log(newVal);
      }
    }
  },
  methods: {
    submitForm: function submitForm(formName) {
      var _this = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          console.log("true");
          _this.$emit("getFormData", _this.form);
        } else {
          console.log("false");
        }
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.autoFormData.forEach(function (item) {
      if (item.defaultValue) {
        _this2.$set(_this2.form, item.code, item.defaultValue);
      } else {
        if (item.type == "checkbox") {
          _this2.$set(_this2.form, item.code, []);
        } else if (item.type == "switch") {
          _this2.$set(_this2.form, item.code, false);
        } else {
          _this2.$set(_this2.form, item.code, "");
        }
      }
    });

    this.formListData = this.autoFormData;
  }
});

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CustomForm_vue__ = __webpack_require__(2);
/*
 * @description:
 * @Author: xinliu
 * @Date: 2022-03-18 10:09:22
 * @LastEditors: xinliu
 * @LastEditTime: 2022-03-18 14:34:01
 */

var components = {
  install: function install(Vue) {
    Vue.component("CustomForm", __WEBPACK_IMPORTED_MODULE_0__CustomForm_vue__["a" /* default */]);
  }
};
if (typeof window !== "undefined" && window.Vue) {
  window.Vue.use(components);
}
/* harmony default export */ __webpack_exports__["default"] = (components);

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomForm_vue__ = __webpack_require__(0);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14d1b81d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomForm_vue__ = __webpack_require__(4);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14d1b81d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 3 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-form',{ref:"autoForm",class:_vm.formClass,attrs:{"inline":_vm.inline,"model":_vm.form,"label-width":"140px"}},[_vm._l((_vm.formListData),function(item){return _c('el-form-item',{key:item.code,attrs:{"label":item.title,"rules":item.rules,"prop":item.code}},[(item.type == 'input' && item.inputType == 'text')?_c('el-input',{attrs:{"placeholder":item.placeholder ? item.placeholder : '',"type":"text","show-word-limit":item.maxlength && item.maxlength > 0,"maxlength":item.maxlength ? item.maxlength : ''},model:{value:(_vm.form[item.code]),callback:function ($$v) {_vm.$set(_vm.form, item.code, $$v)},expression:"form[item.code]"}}):_vm._e(),_vm._v(" "),(item.type == 'input' && item.inputType == 'password')?_c('el-input',{attrs:{"placeholder":item.placeholder ? item.placeholder : '',"type":"password","show-word-limit":item.maxlength && item.maxlength > 0,"maxlength":item.maxlength ? item.maxlength : ''},model:{value:(_vm.form[item.code]),callback:function ($$v) {_vm.$set(_vm.form, item.code, $$v)},expression:"form[item.code]"}}):_vm._e(),_vm._v(" "),(item.type == 'textarea')?_c('el-input',{attrs:{"type":"textarea","placeholder":item.placeholder,"maxlength":item.maxlength ? item.maxlength : '',"show-word-limit":item.maxlength && item.maxlength > 0},model:{value:(_vm.form[item.code]),callback:function ($$v) {_vm.$set(_vm.form, item.code, $$v)},expression:"form[item.code]"}}):_vm._e(),_vm._v(" "),(item.type == 'input' && item.inputType == 'number')?_c('el-input',{attrs:{"type":"number","placeholder":item.placeholder},model:{value:(_vm.form[item.code]),callback:function ($$v) {_vm.$set(_vm.form, item.code, $$v)},expression:"form[item.code]"}}):_vm._e(),_vm._v(" "),(item.type == 'select')?_c('el-select',{attrs:{"placeholder":item.placeholder},model:{value:(_vm.form[item.code]),callback:function ($$v) {_vm.$set(_vm.form, item.code, $$v)},expression:"form[item.code]"}},_vm._l((item.selectOptions),function(selectOption){return _c('el-option',{key:selectOption.id,attrs:{"label":selectOption.label,"value":selectOption.value}})}),1):_vm._e(),_vm._v(" "),(item.type == 'checkbox')?_c('el-checkbox-group',{model:{value:(_vm.form[item.code]),callback:function ($$v) {_vm.$set(_vm.form, item.code, $$v)},expression:"form[item.code]"}},_vm._l((item.selectOptions),function(checkOption){return _c('el-checkbox',{key:checkOption.id,attrs:{"label":checkOption.value}},[_vm._v(_vm._s(checkOption.label))])}),1):_vm._e(),_vm._v(" "),(item.type == 'radio')?_c('el-radio-group',{model:{value:(_vm.form[item.code]),callback:function ($$v) {_vm.$set(_vm.form, item.code, $$v)},expression:"form[item.code]"}},_vm._l((item.selectOptions),function(radioOption){return _c('el-radio',{key:radioOption.id,attrs:{"label":radioOption.value}},[_vm._v(_vm._s(radioOption.label))])}),1):_vm._e(),_vm._v(" "),(item.type == 'switch')?_c('el-switch',{model:{value:(_vm.form[item.code]),callback:function ($$v) {_vm.$set(_vm.form, item.code, $$v)},expression:"form[item.code]"}}):_vm._e(),_vm._v(" "),(item.type == 'datepicker')?_c('el-date-picker',{attrs:{"type":"date","placeholder":item.placeholder,"value-format":item.valueFormat ? item.valueFormat : 'timestamp',"pickerOptions":item.pickerOptions ? item.pickerOptions : ''},model:{value:(_vm.form[item.code]),callback:function ($$v) {_vm.$set(_vm.form, item.code, $$v)},expression:"form[item.code]"}}):_vm._e(),_vm._v(" "),(item.type == 'weekpicker')?_c('el-date-picker',{attrs:{"type":"week","format":item.format ? item.format : 'yyyy年 第 WW 周',"placeholder":item.placeholder,"value-format":item.valueFormat ? item.valueFormat : 'timestamp',"pickerOptions":item.pickerOptions ? item.pickerOptions : ''},model:{value:(_vm.form[item.code]),callback:function ($$v) {_vm.$set(_vm.form, item.code, $$v)},expression:"form[item.code]"}}):_vm._e(),_vm._v(" "),(item.type == 'monthpicker')?_c('el-date-picker',{attrs:{"type":"month","placeholder":item.placeholder,"format":item.format ? item.format : 'yyyy-MM',"value-format":item.valueFormat ? item.valueFormat : 'timestamp',"pickerOptions":item.pickerOptions ? item.pickerOptions : ''},model:{value:(_vm.form[item.code]),callback:function ($$v) {_vm.$set(_vm.form, item.code, $$v)},expression:"form[item.code]"}}):_vm._e(),_vm._v(" "),(item.type == 'yearpicker')?_c('el-date-picker',{attrs:{"type":"year","placeholder":item.placeholder,"format":item.format ? item.format : 'yyyy年',"value-format":item.valueFormat ? item.valueFormat : 'timestamp',"pickerOptions":item.pickerOptions ? item.pickerOptions : ''},model:{value:(_vm.form[item.code]),callback:function ($$v) {_vm.$set(_vm.form, item.code, $$v)},expression:"form[item.code]"}}):_vm._e(),_vm._v(" "),(item.type == 'daterangepicker')?_c('el-date-picker',{attrs:{"type":"daterange","range-separator":item.seprator ? item.seprator : '至',"start-placeholder":item.startPlaceholder ? item.startPlaceholder : '开始日期',"end-placeholder":item.endPlaceholder ? item.endPlaceholder : '结束日期',"format":item.format ? item.format : 'yyyy-MM-dd',"value-format":item.valueFormat ? item.valueFormat : 'timestamp',"pickerOptions":item.pickerOptions ? item.pickerOptions : ''},model:{value:(_vm.form[item.code]),callback:function ($$v) {_vm.$set(_vm.form, item.code, $$v)},expression:"form[item.code]"}}):_vm._e(),_vm._v(" "),(item.type == 'monthrangepicker')?_c('el-date-picker',{attrs:{"type":"monthrange","range-separator":item.seprator ? item.seprator : '至',"start-placeholder":item.startPlaceholder ? item.startPlaceholder : '开始月份',"end-placeholder":item.endPlaceholder ? item.endPlaceholder : '结束月份',"format":item.format ? item.format : 'yyyy-MM',"value-format":item.valueFormat ? item.valueFormat : 'timestamp',"pickerOptions":item.pickerOptions ? item.pickerOptions : ''},model:{value:(_vm.form[item.code]),callback:function ($$v) {_vm.$set(_vm.form, item.code, $$v)},expression:"form[item.code]"}}):_vm._e(),_vm._v(" "),(item.type == 'timepicker')?_c('el-time-picker',{attrs:{"placeholder":item.placeholder,"picker-options":item.pickerOptions ? item.pickerOptions : {},"value-format":item.valueFormat ? item.valueFormat : 'HH:mm:ss',"pickerOptions":item.pickerOptions ? item.pickerOptions : ''},model:{value:(_vm.form[item.code]),callback:function ($$v) {_vm.$set(_vm.form, item.code, $$v)},expression:"form[item.code]"}}):_vm._e(),_vm._v(" "),(item.type == 'timerangepicker')?_c('el-time-picker',{attrs:{"is-range":"","range-separator":item.seprator ? item.seprator : '至',"start-placeholder":item.startPlaceholder ? item.startPlaceholder : '开始时间',"end-placeholder":item.endPlaceholder ? item.endPlaceholder : '结束时间',"value-format":item.valueFormat ? item.valueFormat : 'HH:mm:ss',"pickerOptions":item.pickerOptions ? item.pickerOptions : ''},model:{value:(_vm.form[item.code]),callback:function ($$v) {_vm.$set(_vm.form, item.code, $$v)},expression:"form[item.code]"}}):_vm._e(),_vm._v(" "),(item.type == 'datetimepicker')?_c('el-date-picker',{attrs:{"type":"datetime","placeholder":item.placeholder ? item.placeholder : '请选择',"value-format":item.valueFormat ? item.valueFormat : 'timestamp',"pickerOptions":item.pickerOptions ? item.pickerOptions : ''},model:{value:(_vm.form[item.code]),callback:function ($$v) {_vm.$set(_vm.form, item.code, $$v)},expression:"form[item.code]"}}):_vm._e(),_vm._v(" "),(item.type == 'datetimerangepicker')?_c('el-date-picker',{attrs:{"type":"datetimerange","picker-options":item.pickerOptions ? item.pickerOptions : {},"range-separator":item.separator ? item.separator : '至',"start-placeholder":item.startPlaceholder ? item.startPlaceholder : '开始时间',"end-placeholder":item.endPlaceholder ? item.endPlaceholder : '结束时间',"value-format":item.valueFormat ? item.valueFormat : 'timestamp',"pickerOptions":item.pickerOptions ? item.pickerOptions : ''},model:{value:(_vm.form[item.code]),callback:function ($$v) {_vm.$set(_vm.form, item.code, $$v)},expression:"form[item.code]"}}):_vm._e()],1)}),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"submit"},on:{"click":function($event){return _vm.submitForm('autoForm')}}},[_vm._v("提交")])],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// CustomForm.js